import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {map} from "rxjs/operators";
import {ReplaceDates} from "../_decorators/date.decorator";
import {HttpClient} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {AlertService} from "./alert.service";
import {BehaviorSubject, Observable} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class AuthenticationService {
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(public http: HttpClient, public router: Router,
              public dialogRef: MatDialog,
              public alertService: AlertService,
              public config: IndexConfigService) {

    let currentUser = sessionStorage.getItem('currentUser');
    if (currentUser != null) {
      this.loggedIn.next(true);
    }
  }

  private handleLogin(request: Observable<any>, tenantName: string): Observable<any> {
    return request.pipe(map((response: any) => {
      // login successful if there's a jwt token in the response
      let user = response;
      const tenantUser = ((user || {}).tokens || []).find(t => t.key.tenantName.toLowerCase() === tenantName.toLowerCase());
      if (tenantUser) {
        user.token = tenantUser.value;
        user.fileAccessKey = tenantUser.key.fileAccessKey;
        user.role = tenantUser.key.role;
        //console.log(user.token);

        ReplaceDates(user);

        user.isCurrentUser = true;
        user.tenantName = tenantName;
        // store user details and jwt token in local storage to keep user logged in between page refreshes

        sessionStorage.setItem('currentUser', JSON.stringify(user));
        this.loggedIn.next(true);
      }

      return user;
    }));
  }

  login(username: string, password: string, mfaCode: string, tenantName: string) {

    let body = {username: username, password: password, tenantName: tenantName, mfaCode: mfaCode};

    return this.handleLogin(this.http.post<any>(this.config.api + '/api/authenticate/user', body), tenantName);
  }

  loginOidc(token: string, tenantName: string) {
    let body = {token: token, tenantName: tenantName};
    return this.handleLogin(this.http.post<any>(this.config.api + '/api/authenticate/user/oidc', body), tenantName);
  }

  loginAzure(token: string, tenantName: string) {

    let body = {token: token, tenantName: tenantName};

    return this.http.post<any>(this.config.api + '/api/authenticate/user/azure', body)
      .pipe(map((response: any) => {
        // login successful if there's a jwt token in the response
        let user = response.json();
        if (user && user.token) {

          //console.log(user.token);

          ReplaceDates(user);

          user.isCurrentUser = true;
          user.tenantName = tenantName;
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          sessionStorage.setItem('currentUser', JSON.stringify(user));
          this.loggedIn.next(true);
        }

        return user;
      }));
  }

  loginInq(token: string) {

    const tenant = document.location.hostname.split('.')[0];
    let body = {token: token, tenantName: tenant === 'localhost' ? 'test26' : tenant};

    return this.http.post<any>(this.config.api + '/api/authenticate/user/inq', body)
      .pipe(map((response: any) => {
        // login successful if there's a jwt token in the response
        let user = response;
        user.sso = true;
        if (user && user.token) {

          //console.log(user.token);

          ReplaceDates(user);

          user.isCurrentUser = true;
          user.tenantName = user.tenantName;
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          sessionStorage.setItem('currentUser', JSON.stringify(user));
          this.loggedIn.next(true);
        }

        return user;
      }));
  }

  loginSupport(i: string) {

    return this.http.post<any>(this.config.api + '/api/authenticate/user/support/' + i, {})
      .pipe(map((response: any) => {
        // login successful if there's a jwt token in the response
        let user = response.json();
        if (user && user.token) {

          //console.log(user.token);

          ReplaceDates(user);

          user.isCurrentUser = true;
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          sessionStorage.setItem('currentUser', JSON.stringify(user));
          this.loggedIn.next(true);
        }

        return user;
      }));
  }

  isSso() {
    return !!(JSON.parse(sessionStorage.getItem('currentUser')) || {}).sso;
  }

  cleanupTokens() {
    // remove user from local storage to log user out
    this.dialogRef.closeAll();
    this.alertService.loading.next(false);
    sessionStorage.removeItem('currentUser');

    this.loggedIn.next(false);
  }

  public logout() {
    const user = JSON.parse(sessionStorage.getItem('currentUser'));
    if (user) {
      this.http.get<any>(this.config.api + `/api/authenticate/logout?tenantName=${user.tenantName}&email=${user.emailAddress}`).subscribe(() => {});
    }
    this.cleanupTokens();
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get('returnUrl');
    if (!location.pathname.startsWith('/login')) {
      this.router.navigate(['/login'], {queryParams: {returnUrl: returnUrl}});
    }
  }


  public terminateSessions() {
    this.alertService.loading.next(true);
    this.http.get<any>(this.config.api + '/api/authenticate/terminateSessions').subscribe(() => {
      this.alertService.loading.next(false);
      this.logout();
    },
      error => {
        this.alertService.loading.next(false);
    });
  }

  public logoutAllSessions(){
    window['logoutProtection'] = true;
    setTimeout(() => window['logoutProtection'] = false, 10000);
    this.http.get<any>(this.config.api + '/api/authenticate/logoutAllSessions').subscribe(() => {
    });
  }
}
